import axios from 'axios';
import Cookies from 'js-cookie';
import Base_URL from '../config/apiConfig';

const backendAPI = axios.create({
  baseURL: Base_URL,
  withCredentials: false, // No need when using headers
  timeout: 60000, // 60 seconds timeout
});

// Attach token to every request
backendAPI.interceptors.request.use((config) => {
  const token = Cookies.get('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor to handle timeout errors
backendAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      const timeoutError = new Error(
        'Request timeout. The server is taking too long to respond. Please try again.',
      );
      timeoutError.isTimeout = true;
      return Promise.reject(timeoutError);
    }
    return Promise.reject(error);
  },
);

export default backendAPI;
